window.LR = (function(){
  const fmt = n => n.toLocaleString(undefined,{style:'currency',currency:'USD'});
  const pad2 = n => String(n).padStart(2,'0');
  const todayISO = () => new Date().toISOString().slice(0,10);
  const RATES = { baseOneWay:100, baseRoundTrip:175, perMile:4.00, freeMiles:10, remoteFee:75, remoteThreshold:50 };

  function updateEstimate(root){
    const miles = parseFloat(root.querySelector('#miles')?.value || '0');
    const tripType = (root.querySelector('#tripType')?.value || 'one-way');
    const baseDist = parseFloat(root.querySelector('#baseDistanceMi')?.value || '0'); // 78577 -> pickup
    let est = 0, traveledMiles = 0, chargeMiles = 0;

    if (tripType === 'round-trip') {
      const totalMiles = miles * 2;
      traveledMiles = totalMiles;
      chargeMiles = Math.max(0, totalMiles - RATES.freeMiles);
      est = RATES.baseRoundTrip + (chargeMiles * RATES.perMile);
    } else {
      traveledMiles = miles;
      chargeMiles = Math.max(0, miles - RATES.freeMiles);
      est = RATES.baseOneWay + (chargeMiles * RATES.perMile);
    }

    let remoteApplied = false;
    if (baseDist >= RATES.remoteThreshold) { est += RATES.remoteFee; remoteApplied = true; }

    const out = root.querySelector('#priceEstimate');
    if(out) out.textContent = (est>0?fmt(est):'$—');

    const remoteLine = root.querySelector('#remoteNote');
    if(remoteLine){
      if(remoteApplied){
        remoteLine.textContent = `Includes remote pickup surcharge $${RATES.remoteFee} (pickup ${baseDist.toFixed(1)} mi from 78577)`;
        remoteLine.style.display = '';
      } else {
        remoteLine.textContent = '';
        remoteLine.style.display = 'none';
      }
    }

    const detail = root.querySelector('#milesDetail');
    if(detail){
      if (traveledMiles > 0){
        const rt = (tripType === 'round-trip') ? ' round trip' : '';
        detail.innerHTML = `(<span>includes first ${RATES.freeMiles} mi free; </span><small><strong>traveling${rt} ${traveledMiles.toFixed(1)} mi</strong></small>)`;
      } else { detail.textContent = `(first ${RATES.freeMiles} mi free)`; }
    }
  }

  function calendar(root){
    const grid = root.querySelector('#calGrid'), slots = root.querySelector('#slotGrid'), title = root.querySelector('#calTitle');
    const prev = root.querySelector('#prevMonth'), next = root.querySelector('#nextMonth');
    const dateInput = root.querySelector('#pickupDate'), timeInput = root.querySelector('#pickupTime');
    let cursor = new Date(), selectedDate = null;
    function renderCal(){
      title.textContent = cursor.toLocaleString(undefined,{month:'long',year:'numeric'}); grid.innerHTML='';
      ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].forEach(n => grid.insertAdjacentHTML('beforeend', '<div class="lr-dn">'+n+'</div>'));
      const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
      const start = new Date(first); start.setDate(1-first.getDay());
      for(let i=0;i<42;i++){ const d=new Date(start); d.setDate(start.getDate()+i);
        const isPast = d < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        const btn=document.createElement('button'); btn.type='button'; btn.className='lr-date'; btn.textContent=d.getDate();
        btn.dataset.date = d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate());
        if(isPast) btn.disabled=true;
        btn.addEventListener('click',function(){ selectedDate=d; dateInput.value=btn.dataset.date;
          grid.querySelectorAll('.lr-date').forEach(x => x.classList.remove('lr-selected')); btn.classList.add('lr-selected'); renderSlots(); });
        grid.appendChild(btn);
      }
    }
    function addMinutes(dt,m){ return new Date(dt.getTime()+m*60000); }
    function renderSlots(){ slots.innerHTML=''; if(!selectedDate){ slots.textContent='Choose a date above.'; return; }
      const now=new Date(), start=new Date(selectedDate); start.setHours(6,0,0,0); const end=new Date(selectedDate); end.setHours(20,0,0,0);
      for(let t=new Date(start); t<end; t=addMinutes(t,30)){ const leadOK=(t.getTime()-now.getTime())>=120*60000;
        const b=document.createElement('button'); b.type='button'; b.className='lr-slot'; b.textContent=t.toLocaleTimeString([], {hour:'numeric', minute:'2-digit'});
        b.disabled=!leadOK; b.addEventListener('click',function(){ timeInput.value = pad2(t.getHours())+':'+pad2(t.getMinutes());
          slots.querySelectorAll('.lr-slot').forEach(x => x.classList.remove('lr-selected')); b.classList.add('lr-selected'); });
        slots.appendChild(b);
      }}
    prev.addEventListener('click',function(){ cursor.setMonth(cursor.getMonth()-1); renderCal(); });
    next.addEventListener('click',function(){ cursor.setMonth(cursor.getMonth()+1); renderCal(); });
    renderCal();
  }

  function init(root=document){
    const pd=root.querySelector('#pickupDate'); if(pd) pd.value=todayISO();
    root.querySelectorAll('#miles,#tripType,#baseDistanceMi').forEach(el => { el.addEventListener('input', () => updateEstimate(root)); el.addEventListener('change', () => updateEstimate(root)); });
    updateEstimate(root); if(root.querySelector('#calGrid')) calendar(root);
  }
  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  return { init, updateEstimate };
})();

// --- LR Checkout Submit Handler ---
function removeExistingDeposits(handle){
  // Remove all cart items before adding new deposit
  return fetch('/cart.js', {headers:{'Accept':'application/json'}})
    .then(r=>r.json()).then(cart=>{
      if(!cart.items || !cart.items.length) return;
      const actions = cart.items.map(it=>fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: it.key, quantity: 0 })
      }));
      return Promise.all(actions);
    }).catch(()=>{});
}

function clearCart(){
  // Shopify official endpoint to empty cart
  return fetch('/cart/clear.js', { method:'POST', headers:{'Accept':'application/json'} })
    .then(function(r){ try { return r.json(); } catch(e){ return {}; } })
    .catch(function(){});
}

function removeDepositOnly(handle){
  return fetch('/cart.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var items = (cart && cart.items) ? cart.items : [];
      var matches = items.filter(function(it){ return it.handle === handle; });
      if(!matches.length) return;
      return Promise.all(matches.map(function(it){
        return fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: it.key, quantity: 0 })
        });
      }));
    });
}

function resolveDepositVariant(tripType, handle){
  var docEl = document.documentElement;
  var vOne = docEl.getAttribute('data-one-way-variant-id');
  var vRound = docEl.getAttribute('data-round-trip-variant-id');
  var vGeneric = docEl.getAttribute('data-deposit-variant-id');

  // Priority: explicit trip-specific variant, then generic variant, then lookup by handle+title match
  var direct = (tripType==='round-trip' ? vRound : vOne) || vGeneric;
  if (direct && /^\d+$/.test(String(direct))) return Promise.resolve(direct);

  // Fallback: fetch product and try to match variant title by keywords
  return fetch('/products/' + encodeURIComponent(handle) + '.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(prod){
      var variants = prod.variants || [];
      var key = (tripType==='round-trip') ? 'round' : 'one';
      var guess = variants.find(function(v){
        var t = (v.title||'').toLowerCase();
        return key==='round' ? (t.includes('round') || t.includes('two')) : (t.includes('one') || t.includes('one-way') || t.includes('1'));
      }) || variants[0];
      if(!guess) throw new Error('No deposit variant found');
      return guess.id;
    });
}
document.addEventListener('submit', function(e){
  var form = e.target;
  if(!(form && form.closest && form.closest('#book'))) return;
  e.preventDefault();
  try{
    var root = form;
    var get = id => root.querySelector('#'+id);
    var val = (id) => (get(id)?.value || '').trim();
    var sel = (id) => (get(id)?.options[get(id).selectedIndex].value || '').trim();
    var miles = parseFloat(val('miles') || '0');
    var tripType = sel('tripType') || 'one-way';
    var estimateText = document.querySelector('#priceEstimate')?.textContent || '$0.00';
    var remoteNote = document.querySelector('#remoteNote')?.style.display === '' ? 'Yes' : 'No';

    var properties = {
      "Service": "Wheelchair Ride",
      "Pickup address": val('pickupAddress'),
      "Dropoff address": val('dropoffAddress'),
      "Pickup date": val('pickupDate'),
      "Pickup time": val('pickupTime'),
      "Passenger": (root.querySelector('input[name="passenger"]')?.value || '').trim(),
      "Trip type": tripType,
      "Estimated miles": (isFinite(miles)? miles.toFixed(1) : ''),
      "Instant estimate": estimateText,
      "Remote-area fee applied": remoteNote,
      "Notes": (root.querySelector('textarea[name="notes"]')?.value || '').trim(),
      "Broker": "LeonRideCare (broker)"
    };

    var orderAttributes = {
      "Contact name": (root.querySelector('input[name="contactName"]')?.value || '').trim(),
      "Contact phone": (root.querySelector('input[name="contactPhone"]')?.value || '').trim()
    };

    // Save order-level attributes first
    var saveAttrsPromise = fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body: JSON.stringify({ attributes: orderAttributes })}).catch(function(){});

    // Determine deposit product to add
    var handle = document.documentElement.getAttribute('data-deposit-handle') || 'wheelchair-ride-deposit';
    var variantIdSetting = document.documentElement.getAttribute('data-deposit-variant-id');

    function addToCart(variantId){
      return fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: properties
        })
      }).then(function(r){ return r.json(); });
    }

    function goCheckout(){ window.location = '/checkout'; }

    (function start(){
      if(variantIdSetting){
        Promise.all([saveAttrsPromise, addToCart(variantIdSetting)]).then(function(v){ return Promise.all([saveAttrsPromise, v]); }).then(goCheckout).catch(function(){ goCheckout(); });
        return;
      }
      // Resolve variant via product JSON
      fetch('/products/' + encodeURIComponent(handle) + '.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(prod){
          var v = (prod.variants || []).find(function(x){ return x.available; }) || (prod.variants||[])[0];
          if(!v) throw new Error('No variant for deposit product');
          return addToCart(v.id);
        })
        .then(goCheckout)
        .catch(function(){
          // Fallback: go to product page with query params for properties
          var url = '/products/' + encodeURIComponent(handle) + '?' + new URLSearchParams(properties).toString();
          window.location = url;
        });
    })();

  }catch(err){
    console.error('LR submit error', err);
    // As a last resort, let the original form proceed
    form.submit();
  }
}, true);


document.addEventListener('click', function(e){
  var t = e.target;
  if (!t || t.id !== 'lr-remove-deposit') return;
  e.preventDefault();
  t.disabled = true;
  t.setAttribute('aria-busy','true');
  t.textContent = 'Removing…';
  var handle = document.documentElement.getAttribute('data-deposit-handle') || 'wheelchair-ride-deposit';
  removeDepositOnly(handle)
    .then(function(){ 
      t.textContent = 'Removed!'; 
      // Optional: refresh cart drawer if present
      try { if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.registered['cart-drawer']) location.reload(); } catch(e){}
    })
    .catch(function(){ t.textContent = 'Error — try again'; t.disabled = false; t.removeAttribute('aria-busy'); });
});
